var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgFlagKr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900,
    height: 600,
    viewBox: "-36 -24 72 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-36-24h72v48h-72z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-56.3099325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M-6-26H6v2H-6zm0 3H6v2H-6zm0 3H6v2H-6z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    y: 44
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0,17v10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M0-12A12 12 0 0 1 0 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M0-12A12 12 0 0 0 0 12 6 6 0 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -6,
    fill: "#cd2e3a",
    r: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-123.6900675)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0-23.5v3M0,17v3.5M0,23.5v3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlagKr);
export default __webpack_public_path__ + "static/media/img_flag_kr.466117be2b95dcf37c60a2186d04a54d.svg";
export { ForwardRef as ReactComponent };